// Messages for operator/Security (auto-merged by lib/i18n.ts).
export const en = {
  'operator.security.provider.google': 'Google',
  'operator.security.provider.microsoft': 'Microsoft',
  'operator.security.provider.saml': 'Company SSO (SAML)',
  'operator.security.provider.oidc': 'Company SSO (OIDC)',
  'operator.security.head': 'Security — Operator',
  'operator.security.title': 'Security',
  'operator.security.desc': 'Linked sign-in methods for your account.',
  'operator.security.unlink': 'Unlink',
  'operator.security.none': 'No external identities linked.',
  'operator.security.connect': 'Connect a provider',
}

export const zhTW = {
  'operator.security.provider.google': 'Google',
  'operator.security.provider.microsoft': 'Microsoft',
  'operator.security.provider.saml': '公司 SSO (SAML)',
  'operator.security.provider.oidc': '公司 SSO (OIDC)',
  'operator.security.head': '安全性 — 操作端',
  'operator.security.title': '安全性',
  'operator.security.desc': '您帳戶已連結的登入方式。',
  'operator.security.unlink': '取消連結',
  'operator.security.none': '尚未連結任何外部身分。',
  'operator.security.connect': '連結供應商',
}
